<template>
<DataProvider v-if="idRequest" :endpoint='endpoint' ref='dataProvider' :filter="filter" @closePullingEvent="closePulling()">
  <div slot-scope='{ data: response, error, loading }'>
    <DataTable
      class="workspace-test"
      v-if="response && response.data"
      :data='response && response.data'
      ref='dataTable'
      title="Teste do Workspace"
      :customTotal='(response && response.total) || 0'
      :currentSort.sync='filter.orderBy'
      fileName='resultado_do_teste'
      :currentSortOrder.sync='filter.order'
      :selectable='false'
      :loading='loading || loadingPulling'
      customHeader
      :endpoint='endpoint'
      :filter="filter"
      :labels='labels'
      :formatLabelFunction='formatLabels'
      :createHeader='createHeaderPDF'
      :showPagination='false'
    >
      <template slot='footer' slot-scope='{ pagination }'>
        <v-row style='justify-content: flex-end;'>
          <v-col cols='auto'>
            <md-field>
              <label for='pages'>
                {{ $t('assistantsList.perPage') }}
              </label>

              <md-select v-model='pagination.perPage' name='pages' >
                <md-option
                  v-for='item in pagination.perPageOptions'
                  :key='item'
                  :label='item'
                  :value='item'
                >
                  {{ item }}
                </md-option>
              </md-select>
            </md-field>
          </v-col>
        </v-row>
      </template>

      <template slot='cells' slot-scope='{ item }'>
        <md-table-cell
          :md-label='labels[0]'
        > {{ formatLabels(item, 0) }}
        </md-table-cell>
        <md-table-cell
          :md-label='labels[1]'
        > {{ formatLabels(item, 1) }}
        </md-table-cell>
        <md-table-cell
          :md-label='labels[2]'
        > {{ formatLabels(item, 2) }}
        </md-table-cell>
        <md-table-cell
          :md-label='labels[3]'
        > {{ formatLabels(item, 3) }}
        </md-table-cell>
        <md-table-cell
          :md-label='labels[4]'
        > {{ formatLabels(item, 4) }}
        </md-table-cell>
        <md-table-cell
          :md-label='labels[5]'
        >
          <v-chip outlined :color="getStatusColor(item.result)">{{ formatLabels(item, 5) }}</v-chip>
        </md-table-cell>
        <md-table-cell
          :md-label='labels[6]'
        > {{ formatLabels(item, 6) }}
        </md-table-cell>
      </template>
    </DataTable>
    <div v-else-if="error">{{errorOnGetTest()}}</div>
    <div v-else class="empty-content">
      <v-progress-circular size="70" indeterminate color="primary"></v-progress-circular>
      <div class="waiting-text">Por favor aguarde... os testes estão sendo executados</div>
    </div>
  </div>
</DataProvider>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import Swal from 'sweetalert2'

export default {
  name: 'WorkspaceTest',
  components: {
    DataTable,
    DataProvider
  },
  data () {
    return {
      labels: ['Cenário', 'Tipo de entrada', 'Entrada', 'Resposta', 'Esperado', 'Resultado', 'Detalhes'],
      filter: {
        order: 'asc',
        orderBy: 'createdAt',
        page: 0,
        perPage: 100
      },
      interval: undefined,
      idRequest: undefined,
      loadingPulling: false
    }
  },
  props: {
    selectedSnapshot: {
      type: String,
      required: true
    }
  },
  async created () {
    this.idRequest = await this.getConversationId()
    this.pullingTestList()
  },
  computed: {
    endpoint () {
      return `${process.env.VUE_APP_BACKEND_BASE_URL}/run-tests/${this.idRequest}`
    }
  },
  methods: {
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return item.scenario
        case 1:
          return item.type
        case 2:
          return item.entryText
        case 3:
          return item.answer
        case 4:
          return item.expectedAnswer
        case 5:
          return this.getStatus(item.result)
        case 6:
          return item.detail
        default:
          break
      }
    },
    getStatus (status) {
      return status === 'success' ? 'Sucesso' : 'Falha'
    },
    getStatusColor (status) {
      return status === 'success' ? '#4CAF50' : '#FF5252'
    },
    async getConversationId () {
      const result = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/run-tests`)
      return result.data.conversation_id
    },
    errorOnGetTest () {
      this.$emit('close-dialog')
      Swal.fire({
        icon: 'error',
        title: 'Ops, ocorreu um erro inesperado.',
        html: 'Erro ao realizar testes. Tente novamente mais tarde.'
      })
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, 'Teste Waorkspace')

      // doc.setFontSize(10)
      // doc.setFont('times', undefined, '700')
      // doc.text(15, 17, this.$t('chatTable.timeCourse'))
      // doc.setFont('times', undefined, '300')

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total')
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    pullingTestList () {
      this.loadingPulling = true
      this.interval = setInterval(() => { this.$refs.dataProvider.load() }, 1500)
    },
    closePulling () {
      this.loadingPulling = false
      clearInterval(this.interval)
    }
  },
  beforeDestroy () {
    this.idRequest = ''
    this.closePulling()
  }
}
</script>
<style lang="scss" scoped>
  .workspace-test {
    ::v-deep .md-card-content {
      min-height: 316px;
    }
  }

  .v-chip {
    width: 80px;
    display: flex;
    justify-content: center;
  }

  .empty-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 517px;

    .waiting-text {
      margin-top: 10px;
    }
  }
</style>
